module.exports = __webpack_public_path__ + "img/dashboard-icon-active.6115d4ba.svg";